"use client";

import FadeDiv from "@/components/common/FadeDiv";
import Highlight from "@/components/Highlight";
import Image from "next/image";
import React from "react";
import SectionTitle from "@/components/common/SectionTitle";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

type HighlightedFeaturesProps = {
  title: string;
  description: string;
  points: string[];
  image: React.ReactNode;
}[];

const HighlightedFeatures: React.FC = () => {
  const { t } = useTranslation();

  const features: HighlightedFeaturesProps = [
    {
      title: t("highlight.customer.title"),
      description: t("highlight.customer.description"),
      points: [
        t("highlight.customer.point1"),
        t("highlight.customer.point2"),
        t("highlight.customer.point3"),
      ],
      image: (
        <Image
          src="/images/highlight_customer.webp"
          alt="Insurance"
          width={2656}
          height={2200}
        />
      ),
    },
    {
      title: t("highlight.expert.title"),
      description: t("highlight.expert.description"),
      points: [
        t("highlight.expert.point1"),
        t("highlight.expert.point2"),
        t("highlight.expert.point3"),
      ],
      image: (
        <Image
          src="/images/highlight_expert.webp"
          alt="Insurance"
          width={2656}
          height={2200}
        />
      ),
    },
    {
      title: t("highlight.revenue.title"),
      description: t("highlight.revenue.description"),
      points: [
        t("highlight.revenue.point1"),
        t("highlight.revenue.point2"),
        t("highlight.revenue.point3"),
      ],
      image: (
        <Image
          src="/images/highlight_revenue.webp"
          alt="Insurance"
          width={2656}
          height={2200}
        />
      ),
    },

    {
      title: t("highlight.industry.title"),
      description: t("highlight.industry.description"),
      points: [
        t("highlight.industry.point1"),
        t("highlight.industry.point2"),
        t("highlight.industry.point3"),
      ],
      image: (
        <Image
          src="/images/highlight_industry.webp"
          alt="Insurance"
          width={2656}
          height={2200}
        />
      ),
    },
  ];

  return (
    <div className={clsx("relative bg-gradient-to-b from-white to-[#FFFCF5]")}>
      <FadeDiv
        className={clsx(
          "border-x border-[#DADADA] relative max-w-8xl mx-5 lg:mx-auto"
        )}
      >
        <SectionTitle title={t("highlightedFeatures.title")} />
        <div className={clsx("grid", "gap-12", "md:gap-16")}>
          {features.map((feature, index) => (
            <Highlight
              key={index}
              title={feature.title}
              description={feature.description}
              points={feature.points}
              image={feature.image}
              imageOnLeft={index % 2 === 1}
            />
          ))}
        </div>
      </FadeDiv>
    </div>
  );
};

export default HighlightedFeatures;
